import { render, staticRenderFns } from "./xc.vue?vue&type=template&id=0ecc98ba&scoped=true&"
import script from "./xc.vue?vue&type=script&lang=js&"
export * from "./xc.vue?vue&type=script&lang=js&"
import style0 from "./xc.vue?vue&type=style&index=0&id=0ecc98ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc98ba",
  null
  
)

export default component.exports